import { Button, HStack, Text } from "@chakra-ui/react";
import { Form, Parts, UI } from "components";
import { API } from "config";
import { toaster } from "config";
import { useState } from "react";

export default function Activate(){

    const [ loading, setLoading ] = useState(false)
    const [ error, setError ] = useState(false)
    const [ pad, setPad ] = useState()
    const [ activate, setActivate ] = useState(false)

    const handleChangePad = e => {
        setPad(e.target.value)
        setError(false)
    }

    const handleActivate = async () => {
        setLoading(true)
        setError(false)

        try{
            const callback = await API.get(`/activate/${pad}`)
            setActivate(callback.data)
        }catch(err){
            setError(err?.response?.data?.message)
            toaster.create({ title: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }
    return(
    <>
    <Parts.Dialog.Vouchers.Activate open={!!activate} data={activate} onClose={() => setActivate(false)} />

    <UI.Box>
        <Text fontSize="lg" fontWeight="bold" color="orange"><UI.Icon name="check" /> Ativar cadastro</Text>
        <Text fontSize="sm" color="GrayText">Insira abaixo o código do pedido de adesão para utilizar o voucher.</Text>

        <Form.Container mt={4} autocomplete="off" onSubmit={handleActivate}>

            <HStack>
                <Form.Text
                    required
                    placeholder="Ex.: PAD12345"
                    size="lg"
                    fontWeight="bold"
                    minLength="5"
                    maxLength="12"
                    textTransform="uppercase"
                    value={pad}
                    onChange={handleChangePad}
                    disabled={loading}
                    error={error}
                />
                <Button type="submit" size="md" colorPalette="orange" mt={-2} disabled={!pad || pad?.length < 5} loading={loading}>Ativar</Button>
            </HStack>

            <UI.Alert size="sm" colorPalette="info">
                Você precisa ter o kit escolhido pelo cliente, disponível para ativação.
            </UI.Alert>

        </Form.Container>
    </UI.Box>
    </>
    )
}